export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-02_EN.558c99dd.png";